import './style.css'
import Experience from './Experience/Experience.js'

const canvas = document.querySelector('.webgl')
const experience = new Experience(canvas)

